<template>
  <DialogCard :title="theTitle" :actions="actions">
     <v-container>
    <v-tabs >
      <v-tab>Treatment Mappings</v-tab>
      <v-tab-item>
   
      <v-row v-if="!mh1BookInfo || !mh1BookInfo.treatments || mh1BookInfo.treatments.length == 0">
        <v-col cols="12">
          <v-alert type="warning">No treatments have been setup for this book in MH1</v-alert>
        </v-col>
      </v-row>
      <v-row  v-else-if="mh1BookInfo && mh1BookInfo.treatments">
        <v-col cols="12">
          <v-simple-table v-if="mappings.length > 0">
              <template>
                <thead>
                    <th>MH1 Treatment</th>
                    <th>PMS Appointment Type</th>
                    <th></th>
                </thead>
                <tbody>
                  <tr v-for="mapping in mappings" :key="mapping.mh1TreatmentId">
                      <td>{{getMappingMh1TreatmentName(mapping)}}</td>
                      <td>{{getMappingPmsAppointmentTypeName(mapping)}}</td>
                      <td><v-btn small icon @click="removeMapping(mapping)">
                        <v-icon color="warning ">mdi-delete</v-icon>
                        </v-btn></td>
                  </tr>
                </tbody>
              </template>
          </v-simple-table>
          <v-alert v-else type="info">
            No mappings defined
          </v-alert>
        </v-col>
      </v-row>
      <v-row align="baseline">
        <v-col cols="5">
            <v-select 
                :items="unmappedTreatments"
                v-model="newMappingTreatmentTypeId" 
                item-text="name" 
                item-value="treatmentId" 
                label="MH1 Treatment"
                hide-selected

                >
                
            </v-select>
        </v-col>
        <v-col cols="5">
            <v-select 
                :items="pmsAppointmentTypes"
                v-model="newMappingAppointmentTypeId" 
                item-text="name" 
                item-value="name" 
                label="PMS Appointment Type"
                >
            </v-select>
        </v-col>
        <v-col cols="2">
            <v-btn
            @click="addMapping()"
            color="primary"
            :disabled="!canAddMapping"
            small icon
            ><v-icon color="primary ">mdi-plus-circle</v-icon></v-btn>
        </v-col>
      </v-row>
    
      </v-tab-item>
 
      <v-tab>Treatment Selection</v-tab>
      <v-tab-item>
    <v-container>
      <v-row v-if="!mh1BookInfo || !mh1BookInfo.treatments || mh1BookInfo.treatments.length == 0">
        <v-col cols="12">
          <v-alert type="warning">No treatments have been setup for this book in MH1</v-alert>
        </v-col>
      </v-row>
      <v-row  v-else-if="mh1BookInfo && mh1BookInfo.treatments">
        <v-col cols="12">
          <v-simple-table v-if="AppointmentTypes.length > 0">
              <template>
                <thead>
                    <th>PMS Appointment Type</th>
                    <th></th>
                </thead>
                <tbody>
                  <tr v-for="type in AppointmentTypes" :key="type.name">
                      <td>{{  (type.name)}}</td>
                      <td><v-btn small icon @click="removeAppointmentType(type)">
                        <v-icon color="warning ">mdi-delete</v-icon>
                        </v-btn></td>
                  </tr>
                </tbody>
              </template>
          </v-simple-table>
          <v-alert v-else type="info">
            No mappings defined
          </v-alert>
        </v-col>
      </v-row>
      <v-row align="baseline">
      
        <v-col cols="5">
            <v-select 
                :items="unmappedAppointmentTypes"
                v-model="newAppointmentType" 
               :item-text="item=> GetAppointmentTypeName(item)"
                label="PMS Appointment Type"
                 item-value="name" 
                >
            </v-select>
        </v-col>
        <v-col cols="2">
            <v-btn
            @click="addAppointmentType()"
            color="primary"
            :disabled="!canAddAppointmentType"
            small icon
            ><v-icon color="primary ">mdi-plus-circle</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-container>
      </v-tab-item>
    </v-tabs>
    </v-container>
  </DialogCard>
</template>
<script>
export default {
  name: "ManageBookDialog",
  props: {
    value: Object,
    mh1BookInfo: Object,
    pmsInfo: Object,
    siteAppointmentTypes: Array
  },
  data() {
    return {
        newMappingAppointmentTypeId: "",
        newMappingTreatmentTypeId: "",
        newAppointmentType:"",
        mappings: [],
        AppointmentTypes: []
    };
  },
  created: function() {
      console.log("ManageBookDialog created", this.mh1BookInfo);
      console.log("pmsAppointmentTypes created", this.pmsAppointmentTypes);
      this.mappings = this.value?.mappings ?? [];
       this.AppointmentTypes = this.value?.appointmentTypes ?? [];
  },
  computed: {
    unmappedTreatments: function() {
      if (!this.mh1BookInfo || !this.mh1BookInfo.treatments || this.mh1BookInfo.treatments.length == 0 || this.mappings?.length == 0) {
        console.log("unmappedTreatments returning nothing", this.mh1BookInfo);
        return this.mh1BookInfo?.treatments ?? [];
      }

      console.log("unmappedTreatments returning something", this.mh1BookInfo, this.mappings);

      return this.mh1BookInfo.treatments.filter(t => !this.mappings.find(m => m.mh1TreatmentId == t.treatmentId));

    },
    unmappedAppointmentTypes: function() {
      if (!this.pmsAppointmentTypes || this.AppointmentTypes?.length == 0) {
        console.log("unmappedAppointmentTypes returning nothing", this.pmsAppointmentTypes);
        return this.pmsAppointmentTypes?? [];
      }

      console.log("unmappedAppointmentTypes returning something", this.pmsAppointmentTypes, this.AppointmentType);
      return this.pmsAppointmentTypes.filter(t => !this.AppointmentTypes.find(m => m.name== t.name));

    },
    
    pmsAppointmentTypes: function() {
        if (!this.pmsInfo.appointmentTypeDefinitionLevel) {
            return this.pmsInfo?.appointmentTypes ?? [];
        }
        switch (this.pmsInfo?.appointmentTypeDefinitionLevel ?? "") {
            case "appointmentBook": 
                return bi.appointmentTypes ?? [];
            case "site": 
                return this.siteAppointmentTypes ?? [];
            case "pms":
            default: 
                return this.pmsInfo?.appointmentTypes ?? [];
        }
    },
    canAddMapping: function() {
      return (this.newMappingAppointmentTypeId && this.newMappingTreatmentTypeId);
    },
      canAddAppointmentType: function() {
      return (this.newAppointmentType);
    },
    theTitle: function () {
      return `Manage Book Sync Features ${this.getBookDisplayName(this.value)}`;
    },
    actions: function () {
      return {
        cancel: {
          text: "Cancel",
          color: "secondary",
          handle: () => {
            return { ...this.value, action: "cancelled" };
          },
        },
        ok: {
          text: "OK",
          color: "primary",
          disabled: () => {
            return false;
          },
          handle: async () => {
            if (this.newMappingTreatmentTypeId) {
              const r = await this.$dialog.confirm({text:`Are you sure you wish to exit before adding the selected Treatment Type ?`});
              if (!r) {
                return false;
              }
            }
            
            return {
              ...this.value,
              mappings: this.mappings,
              AppointmentTypes:this.AppointmentTypes,
              action: "ok",
            };
          },
        },
      };
    },
  },
  methods: {
    GetAppointmentTypeName:function(item)
    {
      // if(!item.abbreviation&& item.abbreviation!=undefined && item.abbreviation.length>0)
      // {
      //   return item.name +' ('+ item.abbreviation+')';
      // }
      // else
      // {
        return item.name;
     // }
    },
    getBookDisplayName: function (bi) {
      return (
        bi.book.name ??
        bi.resources
          ?.map((r) => {
            if (r.name) {
              return `${r.title ?? ""} ${r.name ?? ""}`;
            } else {
              return `${r.title ?? ""} ${r.firstName ?? ""} ${r.surname ?? ""}`;
            }
          })
          ?.join(", ") ??
        "" ??
        bi.book.pmsBookFQId
      );
    },
     addAppointmentType: function() {
      this.AppointmentTypes.push({
         name:  this.newAppointmentType
      });
 console.log("AppointmentType created", this.AppointmentTypes);
    },
    addMapping: function() {
      this.mappings.push({
        mh1TreatmentId: this.newMappingTreatmentTypeId,
        pmsAppointmentTypeId: this.newMappingAppointmentTypeId
      });
      this.newMappingTreatmentTypeId = "";

    },
    getMappingMh1TreatmentName: function(mapping) {
      if (!mapping?.mh1TreatmentId) {
        return "n/a";
      }

      console.log("getMappingMh1TreatmentName", mapping);

      const mh1Treatment = this.mh1BookInfo?.treatments?.find(t => t.treatmentId == mapping.mh1TreatmentId);

      if (!mh1Treatment) {
        return `${mapping.mh1TreatmentId}`;
      }

      return mh1Treatment.name;

    },
    getMappingPmsAppointmentTypeName: function(mapping) {
      if (!mapping?.pmsAppointmentTypeId  || !this.pmsAppointmentTypes) {
        return "n/a";
      }
      const t = this.pmsAppointmentTypes.find(t => t.pmsAppointmentTypeId == mapping.pmsAppointmentTypeId);

      if (!t) {
        return `${mapping.pmsAppointmentTypeId}`
      }

      return t.name;
    },
    getPmsAppointmentTypeName: function(pmsAppointmentTypeId) {
      if (!this.pmsAppointmentTypes) {
        return "n/a";
      }
      const t = this.pmsAppointmentTypes.find(t => t.pmsAppointmentTypeId == pmsAppointmentTypeId);

      if (!t) {
        return `${t.name}`
      }

      return t.name + " ("+t.abbreviation+") " ;
    },
     removeAppointmentType: async function(AppointmentType) {
      console.log("removeAppointmentType", AppointmentType);

      const conf = await this.$dialog.confirm({title: "Warning", text: "Are you sure you want to remove this mapping?"});

      if (!conf) return;

      const i = this.AppointmentTypes.findIndex(m => m.name == AppointmentType.name);
      this.AppointmentTypes.splice(i,1);
    },
    removeMapping: async function(mapping) {
      console.log("removeMapping", mapping);


      const conf = await this.$dialog.confirm({title: "Warning", text: "Are you sure you want to remove this mapping?"});

      if (!conf) return;

      const i = this.mappings.findIndex(m => m.mh1TreatmentId == mapping.mh1TreatmentId);
      this.mappings.splice(i,1);
    }
  },
};
</script>